import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RoutingQueryParamsName } from '@core/router/routing.params';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.events.head'),
        url: RouteEntity.Root + RouteEntity.Events,
        objName: [PrivilegesModules.EventsControl],
    },
    {
        mdId: 2,
        mdName: marker('modules.inventory.navbar'),
        url: RouteEntity.Root + RouteEntity.Inventory,
        objName: [PrivilegesModules.EventsControl],
    },
    {
        mdId: 3,
        mdName: marker('modules.printed-tickets.head'),
        url: RouteEntity.Root + RouteEntity.PrintedTickets,
        objName: [PrivilegesModules.EventsPt],
    },
];

export const thirdLevelMenu: Record<string, MenuItemsModel[]> = {
    [RouteEntity.Events]: [
        {
            mdId: 1,
            mdName: marker('global.labels.info'),
            urlTemplate: RouteEntity.Root + RouteEntity.Events + '/#' + RoutingQueryParamsName.EvtId + '#/' + RouteEntity.Info,
        },
        {
            mdId: 2,
            mdName: marker('modules.inventory.head'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Events +
                '/#' + RoutingQueryParamsName.EvtId + '#/' +
                RouteEntity.Packages,
        },
    ],
};
